import Vue from 'vue'
import Vuex from 'vuex'
import globalParams from './modules/globalParams'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    globalParams
  }
})
